import { render, staticRenderFns } from "./DefinitionSettingsDialog.vue?vue&type=template&id=0b2e8ea1&scoped=true"
import script from "./DefinitionSettingsDialog.vue?vue&type=script&lang=js"
export * from "./DefinitionSettingsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2e8ea1",
  null
  
)

export default component.exports